(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    document.querySelectorAll('[data-explore-root][data-ready]').forEach(previous => previous._dispose?.());
    root.dataset.ready = 'true';
    document.body.append(root);
    const signalController = new AbortController();
    const { signal } = signalController;
    const on = (element, name, listener, options = {}) => element.addEventListener(name, listener, { ...options, signal });
    const panel = root.querySelector('.d2-explore-panel');
    const scroller = root.querySelector('[data-explore-scroll]');
    const bar = document.querySelector('[data-d2-bottom-nav]');
    const triggers = [...document.querySelectorAll('[data-explore-open]')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let opened = false, mounted = false, opener, savedY = 0, closeTimer, inerted = [], resizeObserver;
    const setExpanded = value => triggers.forEach(t => t.setAttribute('aria-expanded', String(value)));
    triggers.forEach(t => { t.setAttribute('role','button'); t.setAttribute('aria-haspopup','dialog'); t.setAttribute('aria-controls', panel.id); t.setAttribute('aria-expanded','false'); });
    const allowBranch = node => node === root || node === bar || node.contains(root) || (bar && node.contains(bar));
    const lockBackground = parent => {
      for (const node of parent.children) {
        if (node === root || node === bar || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(node.tagName)) continue;
        if (allowBranch(node)) lockBackground(node);
        else if (!node.inert) { node.inert = true; inerted.push(node); }
      }
    };
    const unlock = () => {
      inerted.forEach(node => { node.inert = false; }); inerted = [];
      document.documentElement.classList.remove('d2-explore-locked');
      document.documentElement.style.removeProperty('--de-scroll-y');
      window.scrollTo({ top: savedY, behavior: 'instant' });
    };
    const close = ({ focus = true, immediate = false } = {}) => {
      if (!opened) return;
      opened = false; delete root.dataset.open; setExpanded(false); unlock();
      if (focus) opener?.focus({ preventScroll: true });
      clearTimeout(closeTimer);
      if (immediate || reduced.matches) root.hidden = true;
      else closeTimer = setTimeout(() => { if (!opened) root.hidden = true; }, 340);
    };
    const setupRail = section => {
      const rail = section.querySelector('[data-explore-rail]');
      const controls = section.querySelector('[data-explore-controls]');
      const previous = section.querySelector('[data-explore-prev]');
      const next = section.querySelector('[data-explore-next]');
      const rtl = () => getComputedStyle(rail).direction === 'rtl';
      let ticking = false, drag, suppressClick = false;
      const update = () => { const max = rail.scrollWidth - rail.clientWidth; const position = Math.abs(rail.scrollLeft); controls.hidden = max < 2; previous.disabled = position < 2; next.disabled = position > max - 2; ticking = false; };
      const step = direction => { rail.scrollBy({ left: direction * (rtl() ? -1 : 1) * (rail.firstElementChild.getBoundingClientRect().width + 12), behavior: reduced.matches ? 'instant' : 'smooth' }); };
      on(previous,'click',() => step(-1)); on(next,'click',() => step(1));
      on(rail,'scroll',() => { if (!ticking) { ticking = true; requestAnimationFrame(update); } },{ passive: true });
      on(rail,'keydown',event => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); step((event.key === 'ArrowRight' ? 1 : -1) * (rtl() ? -1 : 1)); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); rail.scrollTo({ left: event.key === 'Home' ? 0 : (rtl() ? -1 : 1) * rail.scrollWidth, behavior: reduced.matches ? 'instant' : 'smooth' }); }
      });
      on(rail,'dragstart',event => event.preventDefault());
      on(rail,'pointerdown',event => { if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return; drag = { x:event.clientX, y:event.clientY, left:rail.scrollLeft, id:event.pointerId, active:false }; });
      on(rail,'pointermove',event => {
        if (!drag) return;
        const dx=event.clientX-drag.x, dy=event.clientY-drag.y;
        if (!drag.active && Math.abs(dx)>8 && Math.abs(dx)>Math.abs(dy)) { drag.active=true; rail.setPointerCapture(drag.id); rail.classList.add('is-dragging'); }
        if (drag.active) { event.preventDefault(); rail.scrollLeft=drag.left-dx; }
      });
      const endDrag = () => { if (drag?.active) { suppressClick=true; if (rail.hasPointerCapture(drag.id)) rail.releasePointerCapture(drag.id); rail.classList.remove('is-dragging'); setTimeout(() => { suppressClick=false; },0); } drag=null; };
      on(rail,'pointerup',endDrag); on(rail,'pointercancel',endDrag); on(rail,'pointerleave',() => { if (!drag?.active) drag=null; });
      on(rail,'click',event => { if (suppressClick) { event.preventDefault(); event.stopPropagation(); } },{ capture:true });
      resizeObserver ||= new ResizeObserver(() => root.querySelectorAll('[data-explore-carousel]').forEach(s => s._updateRail?.()));
      section._updateRail=update; resizeObserver.observe(rail); update();
    };
    const mount = () => {
      if (mounted) return;
      mounted=true; scroller.append(root.querySelector('[data-explore-template]').content.cloneNode(true));
      root.querySelectorAll('[data-explore-carousel]').forEach(setupRail);
    };
    const open = trigger => {
      if (opened) return;
      clearTimeout(closeTimer); opener=trigger; mount(); root.hidden=false; opened=true;
      savedY=window.scrollY;
      document.documentElement.style.setProperty('--de-scroll-y', `${-savedY}px`);
      document.documentElement.classList.add('d2-explore-locked'); lockBackground(document.body); setExpanded(true);
      void panel.offsetWidth;
      root.dataset.open='';
      root.querySelector('#D2ExploreTitle')?.focus({ preventScroll:true });
      root.querySelectorAll('[data-explore-carousel]').forEach(s => s._updateRail?.());
    };
    on(document,'click',event => {
      const trigger=event.target.closest('[data-explore-open]');
      if (trigger && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) { event.preventDefault(); open(trigger); return; }
      if (opened && event.target.closest('[data-d2-bottom-nav]')) close({ focus:false, immediate:true });
    },{ capture:true });
    on(document,'keydown',event => {
      if (!opened && event.key===' ' && event.target.matches('[data-explore-open]')) { event.preventDefault(); open(event.target); return; }
      if (!opened) return;
      if (event.key==='Escape') { event.preventDefault(); event.stopPropagation(); close(); return; }
      if (event.key!=='Tab') return;
      const selector='a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]';
      const controls=[...panel.querySelectorAll(selector),...(bar?[...bar.querySelectorAll(selector)]:[])].filter(e=>e.getClientRects().length&&!e.closest('[inert]'));
      const first=controls[0], last=controls.at(-1), current=document.activeElement;
      if (event.shiftKey && (current===first || !controls.includes(current))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (current===last || !controls.includes(current))) { event.preventDefault(); first?.focus(); }
    },{ capture:true });
    on(root,'click',event => {
      if (event.target.closest('[data-explore-close]')) { close(); return; }
      if (event.target.closest('a[href]') && !event.defaultPrevented) close({ focus:false, immediate:true });
    });
    let startedOnBackdrop=false;
    on(root,'pointerdown',event => { startedOnBackdrop=event.target.hasAttribute('data-explore-backdrop'); });
    on(root,'click',event => { if(startedOnBackdrop && event.target.hasAttribute('data-explore-backdrop')) close(); startedOnBackdrop=false; });
    on(window,'pagehide',() => close({ focus:false, immediate:true }));
    on(document,'shopify:section:unload',event => { if (event.detail?.sectionId===root.dataset.sectionId) root._dispose(); });
    root._dispose=() => { close({focus:false,immediate:true}); clearTimeout(closeTimer); resizeObserver?.disconnect(); signalController.abort(); root.remove(); };
  };
  init(document.querySelector('[data-explore-root]'));
  if (!window.rdbExploreEditorListener) {
    window.rdbExploreEditorListener=true;
    document.addEventListener('shopify:section:load',event => init(event.target.querySelector('[data-explore-root]')));
  }
})();
